import { GetterTree } from 'vuex'
import { AccountTypes, KycStatus, PayoutAccountStatuses, SubscriptionTypes, TipaltiAccountTypes } from '@/constants'
import { getCookie } from '@/helpers/getCookie'
import { State } from './state'

const TOKEN_NAME = process.env.VUE_APP_JWT_TOKEN

export default <GetterTree<State, State>> {
  activePayoutMethods(state): PayoutAccount[] {
    return state.payoutAccounts
      .filter(account => account.status === PayoutAccountStatuses.active && account.isVerified)
  },
  unverifiedActivePayoutMethods(state): PayoutAccount[] {
    return state.payoutAccounts.filter(account => !account.isVerified && account.status === PayoutAccountStatuses.active)
  },
  hasNoPayoutMethod(state): boolean {
    return !state.payoutAccounts.length
  },
  hasTipaltiAccount(state): boolean {
    return state.payoutAccounts.some(account => TipaltiAccountTypes.includes(account.type))
  },
  hasPayoneerAccount(state):boolean {
    return state.payoutAccounts.some(account => account.type === AccountTypes.payoneer)
  },
  hasPendingPayoneerAccount(state):boolean {
    return state.payoutAccounts.some(account => account.type === AccountTypes.payoneer
      && account.status === PayoutAccountStatuses.pending)
  },
  hasRejectedPayoneerAccount(state):boolean {
    return state.payoutAccounts.some(account => account.type === AccountTypes.payoneer
      && account.status === PayoutAccountStatuses.blocked)
  },
  isImpersonateMode(state): boolean {
    const isAdmin = getCookie(`DittoMusic[${TOKEN_NAME}Customer]`) !== null
    const sessionId = Number(getCookie('DittoMusic[userId]'))

    return isAdmin && state.user.id !== sessionId
  },
  isWithdrawalReady(state, getters): boolean {
    return state.user.status.payouts
      && !!getters.activePayoutMethods.length
  },
  isSubscriptionMissing(state): boolean {
    return !state.user.subscription
        && !state.user.status?.isSubscriptionNotRequired
  },
  isSuspended(state): boolean {
    return !state.user.status?.notSuspended
  },
  isUserEmailVerified(state): boolean {
    return !!state.user.status?.activated
  },
  isKycVerified(state): boolean {
    return state.user.status?.kyc === KycStatus.approved
  },
  isUserCurrencyGBP(state): boolean {
    return state.userProfile.currency === 'GBP'
  },
  isOnProPlanOrAbove: (state): boolean => !!(
    state.user?.subscription
    && state.user?.subscription.subscriptionPlan.artistLimit > 1
  ),
}
